import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { TableContainer, Table } from '@gogame/components';

import {
  AFFECTED_LEVEL_NAME,
  SECONDARY_AFFECTED_LEVEL_NAME,
} from 'scenes/SmartRules/SmartRuleForm/General';

import AffectedEntitiesBody from './AffectedEntitiesBody';
import AffectedEntitiesHead from './AffectedEntitiesHead';

export const AffectedEntities = ({ data, ruleLogId }) => {
  if (isEmpty(data?.target)) {
    return null;
  }

  const {
    [AFFECTED_LEVEL_NAME]: affectedLevel,
    [SECONDARY_AFFECTED_LEVEL_NAME]: secondaryAffectedLevel,
    metrics,
    actionMetrics,
    affectedEntities,
  } = data;

  return (
    <TableContainer>
      <Table size={'small'}>
        <AffectedEntitiesHead
          secondaryAffectedLevel={secondaryAffectedLevel}
          affectedLevel={affectedLevel}
          actionMetrics={actionMetrics}
          metrics={metrics}
        />
        <AffectedEntitiesBody
          affectedEntities={affectedEntities}
          actionMetrics={actionMetrics}
          metrics={metrics}
          ruleLogId={ruleLogId}
        />
      </Table>
    </TableContainer>
  );
};
